import { useState, useEffect } from "react";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import checkIcon from "../../assets/check-square.png";

const MOBILE_MAX_WIDTH = 767;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return isMobile;
};

const VehicleCard = (vehiculo) => {
  const { openConsultaForm } = useWhatsAppConsulta();
  const tipo = vehiculo.tipo;
  const isMobile = useIsMobile();

  const handleConsultar = (modelo, version, seccion, tipo_financiacion) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      modelo,
      version,
      seccion,
      event: "consultar",
      tipo_financiacion,
    });
    openConsultaForm();
  };

  const getCardInteraction = (modelo, version, tipoFinanciacion) => {
    const onConsult = () => handleConsultar(modelo, version, vehiculo.tipo, tipoFinanciacion);

    return {
      sectionClassName: isMobile ? " card-new-vehicle--tappable" : "",
      sectionOnClick: isMobile ? onConsult : undefined,
      buttonOnClick: isMobile ? undefined : onConsult,
    };
  };

  return (
    <div>
      {vehiculo.info.convencional.habilitado && vehiculo.nombreTipo === "convencional" ? (
        (() => {
          const card = vehiculo.info.convencional;
          const interaction = getCardInteraction(card.modelo, card.version, card.titulo_principal);

          return (
            <section
              className={`card-new-vehicle h-100 d-flex justify-content-between flex-column${interaction.sectionClassName}`}
              onClick={interaction.sectionOnClick}
            >
              <div>
                <div className="card-new-vehicle-header">
                  <h2 className="titulo-tarjeta"> {card.modelo} </h2>
                  {card.version !== "" ? <h3 className="titulo-version-tarjeta"> {card.version} </h3> : null}
                </div>
                <div className="card-new-vehicle-imagen">
                  <img src={card.main_picture} alt={card.modelo} className="img-fluid" />
                </div>
                <div className="card-new-vehicle-footer">
                  {(card.entrega_inmediata || card.entrega_por_encargo) ? (
                    <div className="vehicle-footer-entrega-inmediata">
                      <p>
                        <img src={checkIcon} alt="Icon Check" />
                        {card.entrega_por_encargo ? "ENTREGA POR ENCARGO" : "ENTREGA INMEDIATA"}
                      </p>
                    </div>
                  ) : null}

                  {card.descripcion_general.length !== "" ? (
                    <div className="vehicle-footer-descripcion-general">
                      <p>{card.descripcion_general}</p>
                    </div>
                  ) : null}

                  {card.subtitulo_principal !== "" ? (
                    <div className="vehicle-footer-subtitulo-principal">
                      <p>{card.subtitulo_principal}</p>
                    </div>
                  ) : null}

                  {card.descripcion_subtitulo_principal !== "" ? (
                    <div className="vehicle-footer-descripcion-subtitulo-principal">
                      <p>{card.descripcion_subtitulo_principal}</p>
                    </div>
                  ) : null}

                  <div className="vehicle-footer-titulo-principal">
                    {card.titulo_principal !== "" ? (
                      <p className="vehicle-footer-titulo-principal-a">{card.titulo_principal}</p>
                    ) : null}

                    {card.descripcion_titulo_principal !== "" ? (
                      <p className="vehicle-footer-titulo-principal-b">{card.descripcion_titulo_principal}</p>
                    ) : null}

                    {card.descripcion_rojo_titulo_principal !== "" ? (
                      <p className="vehicle-footer-titulo-principal-c">{card.descripcion_rojo_titulo_principal}</p>
                    ) : null}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="btn-consultar-card"
                id={`${card.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
                onClick={interaction.buttonOnClick}
              >
                Consultar
              </button>
            </section>
          );
        })()
      ) : (
        (() => {
          const card = vehiculo.info.plan;
          const interaction = getCardInteraction(card.modelo, card.version, "plan");

          return (
            <section
              className={`card-new-vehicle h-100 d-flex justify-content-between flex-column${interaction.sectionClassName}`}
              onClick={interaction.sectionOnClick}
            >
              <div>
                <div className="card-new-vehicle-header">
                  <h2 className="titulo-tarjeta"> {card.modelo} </h2>
                  {card.version !== "" ? <h3 className="titulo-version-tarjeta"> {card.version} </h3> : null}
                </div>
                <div className="card-new-vehicle-imagen">
                  <img src={card.main_picture} alt={card.modelo} className="img-fluid" />
                </div>
                <div className="card-new-vehicle-footer">
                  {(card.entrega_inmediata || card.entrega_por_encargo) ? (
                    <div className="vehicle-footer-entrega-inmediata">
                      <p>
                        <img src={checkIcon} alt="Icon Check" />
                        {card.entrega_por_encargo ? "ENTREGA POR ENCARGO" : "ENTREGA INMEDIATA"}
                      </p>
                    </div>
                  ) : null}

                  {card.tipos_planes[0].nombre_plan !== "" ? (
                    <div className="vehicle-footer-planes-cuotas">
                      {card.tipos_planes.map((plan, index) => (
                        <div key={index} className="vehicle-footer-planes-cuotas-card">
                          <div className="vehicle-footer-planes-cuotas-card-header">
                            <p className="cuotas-card-header-titulo">{plan.nombre_plan}</p>
                            <p className="cuotas-card-header-precio">{plan.precio}</p>
                          </div>
                          <div className="vehicle-footer-planes-cuotas-card-footer">
                            <p>{plan.descripcion}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : null}

                  {card.descripcion_general.length !== "" ? (
                    <div className="vehicle-footer-descripcion-general">
                      <p>{card.descripcion_general}</p>
                    </div>
                  ) : null}

                  {card.subtitulo_principal !== "" ? (
                    <div className="vehicle-footer-subtitulo-principal">
                      <p>{card.subtitulo_principal}</p>
                    </div>
                  ) : null}

                  {card.descripcion_subtitulo_principal !== "" ? (
                    <div className="vehicle-footer-descripcion-subtitulo-principal">
                      <p>{card.descripcion_subtitulo_principal}</p>
                    </div>
                  ) : null}

                  <div className="vehicle-footer-titulo-principal">
                    {card.titulo_principal !== "" ? (
                      <p className="vehicle-footer-titulo-principal-a">{card.titulo_principal}</p>
                    ) : null}

                    {card.descripcion_titulo_principal !== "" ? (
                      <p className="vehicle-footer-titulo-principal-b">{card.descripcion_titulo_principal}</p>
                    ) : null}

                    {card.descripcion_rojo_titulo_principal !== "" ? (
                      <p className="vehicle-footer-titulo-principal-c">{card.descripcion_rojo_titulo_principal}</p>
                    ) : null}
                  </div>
                </div>
              </div>

              <button
                type="button"
                className="btn-consultar-card"
                id={`${card.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
                onClick={interaction.buttonOnClick}
              >
                Consultar
              </button>
            </section>
          );
        })()
      )}
    </div>
  );
};

export default VehicleCard;
